export default [
  {
    label: 'Afganistán',
    value: 'af'
  },
  {
    label: 'Alandia',
    value: 'ax'
  },
  {
    label: 'Albania',
    value: 'al'
  },
  {
    label: 'Argelia',
    value: 'dz'
  },
  {
    label: 'Samoa Americana',
    value: 'as'
  },
  {
    label: 'Andorra',
    value: 'ad'
  },
  {
    label: 'Angola',
    value: 'ao'
  },
  {
    label: 'Anguilla',
    value: 'ai'
  },
  {
    label: 'Antártida',
    value: 'aq'
  },
  {
    label: 'Antigua y Barbuda',
    value: 'ag'
  },
  {
    label: 'Argentina',
    value: 'ar'
  },
  {
    label: 'Armenia',
    value: 'am'
  },
  {
    label: 'Aruba',
    value: 'aw'
  },
  {
    label: 'Australia',
    value: 'au'
  },
  {
    label: 'Austria',
    value: 'at'
  },
  {
    label: 'Azerbaiyán',
    value: 'az'
  },
  {
    label: 'Bahamas',
    value: 'bs'
  },
  {
    label: 'Bahrein',
    value: 'bh'
  },
  {
    label: 'Bangladesh',
    value: 'bd'
  },
  {
    label: 'Barbados',
    value: 'bb'
  },
  {
    label: 'Bielorrusia',
    value: 'by'
  },
  {
    label: 'Bélgica',
    value: 'be'
  },
  {
    label: 'Belice',
    value: 'bz'
  },
  {
    label: 'Benín',
    value: 'bj'
  },
  {
    label: 'Bermudas',
    value: 'bm'
  },
  {
    label: 'Bután',
    value: 'bt'
  },
  {
    label: 'Bolivia',
    value: 'bo'
  },
  {
    label: null,
    value: 'bq'
  },
  {
    label: 'Bosnia y Herzegovina',
    value: 'ba'
  },
  {
    label: 'Botswana',
    value: 'bw'
  },
  {
    label: 'Isla Bouvet',
    value: 'bv'
  },
  {
    label: 'Brasil',
    value: 'br'
  },
  {
    label: 'Territorio Británico del Océano Índico',
    value: 'io'
  },
  {
    label: 'Islas Ultramarinas Menores de Estados Unidos',
    value: 'um'
  },
  {
    label: 'Islas Vírgenes del Reino Unido',
    value: 'vg'
  },
  {
    label: 'Islas Vírgenes de los Estados Unidos',
    value: 'vi'
  },
  {
    label: 'Brunei',
    value: 'bn'
  },
  {
    label: 'Bulgaria',
    value: 'bg'
  },
  {
    label: 'Burkina Faso',
    value: 'bf'
  },
  {
    label: 'Burundi',
    value: 'bi'
  },
  {
    label: 'Camboya',
    value: 'kh'
  },
  {
    label: 'Camerún',
    value: 'cm'
  },
  {
    label: 'Canadá',
    value: 'ca'
  },
  {
    label: 'Cabo Verde',
    value: 'cv'
  },
  {
    label: 'Islas Caimán',
    value: 'ky'
  },
  {
    label: 'República Centroafricana',
    value: 'cf'
  },
  {
    label: 'Chad',
    value: 'td'
  },
  {
    label: 'Chile',
    value: 'cl'
  },
  {
    label: 'China',
    value: 'cn'
  },
  {
    label: 'Isla de Navidad',
    value: 'cx'
  },
  {
    label: 'Islas Cocos o Islas Keeling',
    value: 'cc'
  },
  {
    label: 'Colombia',
    value: 'co'
  },
  {
    label: 'Comoras',
    value: 'km'
  },
  {
    label: 'Congo',
    value: 'cg'
  },
  {
    label: 'Congo (Rep. Dem.)',
    value: 'cd'
  },
  {
    label: 'Islas Cook',
    value: 'ck'
  },
  {
    label: 'Costa Rica',
    value: 'cr'
  },
  {
    label: 'Croacia',
    value: 'hr'
  },
  {
    label: 'Cuba',
    value: 'cu'
  },
  {
    label: null,
    value: 'cw'
  },
  {
    label: 'Chipre',
    value: 'cy'
  },
  {
    label: 'República Checa',
    value: 'cz'
  },
  {
    label: 'Dinamarca',
    value: 'dk'
  },
  {
    label: 'Yibuti',
    value: 'dj'
  },
  {
    label: 'Dominica',
    value: 'dm'
  },
  {
    label: 'República Dominicana',
    value: 'do'
  },
  {
    label: 'Ecuador',
    value: 'ec'
  },
  {
    label: 'Egipto',
    value: 'eg'
  },
  {
    label: 'El Salvador',
    value: 'sv'
  },
  {
    label: 'Guinea Ecuatorial',
    value: 'gq'
  },
  {
    label: 'Eritrea',
    value: 'er'
  },
  {
    label: 'Estonia',
    value: 'ee'
  },
  {
    label: 'Etiopía',
    value: 'et'
  },
  {
    label: 'Islas Malvinas',
    value: 'fk'
  },
  {
    label: 'Islas Faroe',
    value: 'fo'
  },
  {
    label: 'Fiyi',
    value: 'fj'
  },
  {
    label: 'Finlandia',
    value: 'fi'
  },
  {
    label: 'Francia',
    value: 'fr'
  },
  {
    label: 'Guayana Francesa',
    value: 'gf'
  },
  {
    label: 'Polinesia Francesa',
    value: 'pf'
  },
  {
    label: 'Tierras Australes y Antárticas Francesas',
    value: 'tf'
  },
  {
    label: 'Gabón',
    value: 'ga'
  },
  {
    label: 'Gambia',
    value: 'gm'
  },
  {
    label: 'Georgia',
    value: 'ge'
  },
  {
    label: 'Alemania',
    value: 'de'
  },
  {
    label: 'Ghana',
    value: 'gh'
  },
  {
    label: 'Gibraltar',
    value: 'gi'
  },
  {
    label: 'Grecia',
    value: 'gr'
  },
  {
    label: 'Groenlandia',
    value: 'gl'
  },
  {
    label: 'Grenada',
    value: 'gd'
  },
  {
    label: 'Guadalupe',
    value: 'gp'
  },
  {
    label: 'Guam',
    value: 'gu'
  },
  {
    label: 'Guatemala',
    value: 'gt'
  },
  {
    label: 'Guernsey',
    value: 'gg'
  },
  {
    label: 'Guinea',
    value: 'gn'
  },
  {
    label: 'Guinea-Bisáu',
    value: 'gw'
  },
  {
    label: 'Guyana',
    value: 'gy'
  },
  {
    label: 'Haiti',
    value: 'ht'
  },
  {
    label: 'Islas Heard y McDonald',
    value: 'hm'
  },
  {
    label: 'Santa Sede',
    value: 'va'
  },
  {
    label: 'Honduras',
    value: 'hn'
  },
  {
    label: 'Hong Kong',
    value: 'hk'
  },
  {
    label: 'Hungría',
    value: 'hu'
  },
  {
    label: 'Islandia',
    value: 'is'
  },
  {
    label: 'India',
    value: 'in'
  },
  {
    label: 'Indonesia',
    value: 'id'
  },
  {
    label: 'Costa de Marfil',
    value: 'ci'
  },
  {
    label: 'Iran',
    value: 'ir'
  },
  {
    label: 'Irak',
    value: 'iq'
  },
  {
    label: 'Irlanda',
    value: 'ie'
  },
  {
    label: 'Isla de Man',
    value: 'im'
  },
  {
    label: 'Israel',
    value: 'il'
  },
  {
    label: 'Italia',
    value: 'it'
  },
  {
    label: 'Jamaica',
    value: 'jm'
  },
  {
    label: 'Japón',
    value: 'jp'
  },
  {
    label: 'Jersey',
    value: 'je'
  },
  {
    label: 'Jordania',
    value: 'jo'
  },
  {
    label: 'Kazajistán',
    value: 'kz'
  },
  {
    label: 'Kenia',
    value: 'ke'
  },
  {
    label: 'Kiribati',
    value: 'ki'
  },
  {
    label: 'Kuwait',
    value: 'kw'
  },
  {
    label: 'Kirguizistán',
    value: 'kg'
  },
  {
    label: 'Laos',
    value: 'la'
  },
  {
    label: 'Letonia',
    value: 'lv'
  },
  {
    label: 'Líbano',
    value: 'lb'
  },
  {
    label: 'Lesotho',
    value: 'ls'
  },
  {
    label: 'Liberia',
    value: 'lr'
  },
  {
    label: 'Libia',
    value: 'ly'
  },
  {
    label: 'Liechtenstein',
    value: 'li'
  },
  {
    label: 'Lituania',
    value: 'lt'
  },
  {
    label: 'Luxemburgo',
    value: 'lu'
  },
  {
    label: 'Macao',
    value: 'mo'
  },
  {
    label: 'Macedonia',
    value: 'mk'
  },
  {
    label: 'Madagascar',
    value: 'mg'
  },
  {
    label: 'Malawi',
    value: 'mw'
  },
  {
    label: 'Malasia',
    value: 'my'
  },
  {
    label: 'Maldivas',
    value: 'mv'
  },
  {
    label: 'Mali',
    value: 'ml'
  },
  {
    label: 'Malta',
    value: 'mt'
  },
  {
    label: 'Islas Marshall',
    value: 'mh'
  },
  {
    label: 'Martinica',
    value: 'mq'
  },
  {
    label: 'Mauritania',
    value: 'mr'
  },
  {
    label: 'Mauricio',
    value: 'mu'
  },
  {
    label: 'Mayotte',
    value: 'yt'
  },
  {
    label: 'México',
    value: 'mx'
  },
  {
    label: 'Micronesia',
    value: 'fm'
  },
  {
    label: 'Moldavia',
    value: 'md'
  },
  {
    label: 'Mónaco',
    value: 'mc'
  },
  {
    label: 'Mongolia',
    value: 'mn'
  },
  {
    label: 'Montenegro',
    value: 'me'
  },
  {
    label: 'Montserrat',
    value: 'ms'
  },
  {
    label: 'Marruecos',
    value: 'ma'
  },
  {
    label: 'Mozambique',
    value: 'mz'
  },
  {
    label: 'Myanmar',
    value: 'mm'
  },
  {
    label: 'Namibia',
    value: 'na'
  },
  {
    label: 'Nauru',
    value: 'nr'
  },
  {
    label: 'Nepal',
    value: 'np'
  },
  {
    label: 'Países Bajos',
    value: 'nl'
  },
  {
    label: 'Nueva Caledonia',
    value: 'nc'
  },
  {
    label: 'Nueva Zelanda',
    value: 'nz'
  },
  {
    label: 'Nicaragua',
    value: 'ni'
  },
  {
    label: 'Níger',
    value: 'ne'
  },
  {
    label: 'Nigeria',
    value: 'ng'
  },
  {
    label: 'Niue',
    value: 'nu'
  },
  {
    label: 'Isla de Norfolk',
    value: 'nf'
  },
  {
    label: 'Corea del Norte',
    value: 'kp'
  },
  {
    label: 'Islas Marianas del Norte',
    value: 'mp'
  },
  {
    label: 'Noruega',
    value: 'no'
  },
  {
    label: 'Omán',
    value: 'om'
  },
  {
    label: 'Pakistán',
    value: 'pk'
  },
  {
    label: 'Palau',
    value: 'pw'
  },
  {
    label: 'Palestina',
    value: 'ps'
  },
  {
    label: 'Panamá',
    value: 'pa'
  },
  {
    label: 'Papúa Nueva Guinea',
    value: 'pg'
  },
  {
    label: 'Paraguay',
    value: 'py'
  },
  {
    label: 'Perú',
    value: 'pe'
  },
  {
    label: 'Filipinas',
    value: 'ph'
  },
  {
    label: 'Islas Pitcairn',
    value: 'pn'
  },
  {
    label: 'Polonia',
    value: 'pl'
  },
  {
    label: 'Portugal',
    value: 'pt'
  },
  {
    label: 'Puerto Rico',
    value: 'pr'
  },
  {
    label: 'Catar',
    value: 'qa'
  },
  {
    label: 'Kosovo',
    value: 'xk'
  },
  {
    label: 'Reunión',
    value: 're'
  },
  {
    label: 'Rumania',
    value: 'ro'
  },
  {
    label: 'Rusia',
    value: 'ru'
  },
  {
    label: 'Ruanda',
    value: 'rw'
  },
  {
    label: 'San Bartolomé',
    value: 'bl'
  },
  {
    label: 'Santa Helena',
    value: 'sh'
  },
  {
    label: 'San Cristóbal y Nieves',
    value: 'kn'
  },
  {
    label: 'Santa Lucía',
    value: 'lc'
  },
  {
    label: 'Saint Martin',
    value: 'mf'
  },
  {
    label: 'San Pedro y Miquelón',
    value: 'pm'
  },
  {
    label: 'San Vicente y Granadinas',
    value: 'vc'
  },
  {
    label: 'Samoa',
    value: 'ws'
  },
  {
    label: 'San Marino',
    value: 'sm'
  },
  {
    label: 'Santo Tomé y Príncipe',
    value: 'st'
  },
  {
    label: 'Arabia Saudí',
    value: 'sa'
  },
  {
    label: 'Senegal',
    value: 'sn'
  },
  {
    label: 'Serbia',
    value: 'rs'
  },
  {
    label: 'Seychelles',
    value: 'sc'
  },
  {
    label: 'Sierra Leone',
    value: 'sl'
  },
  {
    label: 'Singapur',
    value: 'sg'
  },
  {
    label: null,
    value: 'sx'
  },
  {
    label: 'República Eslovaca',
    value: 'sk'
  },
  {
    label: 'Eslovenia',
    value: 'si'
  },
  {
    label: 'Islas Salomón',
    value: 'sb'
  },
  {
    label: 'Somalia',
    value: 'so'
  },
  {
    label: 'República de Sudáfrica',
    value: 'za'
  },
  {
    label: 'Islas Georgias del Sur y Sandwich del Sur',
    value: 'gs'
  },
  {
    label: 'Corea del Sur',
    value: 'kr'
  },
  {
    label: 'Sudán del Sur',
    value: 'ss'
  },
  {
    label: 'España',
    value: 'es'
  },
  {
    label: 'Sri Lanka',
    value: 'lk'
  },
  {
    label: 'Sudán',
    value: 'sd'
  },
  {
    label: 'Surinam',
    value: 'sr'
  },
  {
    label: 'Islas Svalbard y Jan Mayen',
    value: 'sj'
  },
  {
    label: 'Suazilandia',
    value: 'sz'
  },
  {
    label: 'Suecia',
    value: 'se'
  },
  {
    label: 'Suiza',
    value: 'ch'
  },
  {
    label: 'Siria',
    value: 'sy'
  },
  {
    label: 'Taiwán',
    value: 'tw'
  },
  {
    label: 'Tayikistán',
    value: 'tj'
  },
  {
    label: 'Tanzania',
    value: 'tz'
  },
  {
    label: 'Tailandia',
    value: 'th'
  },
  {
    label: 'Timor Oriental',
    value: 'tl'
  },
  {
    label: 'Togo',
    value: 'tg'
  },
  {
    label: 'Islas Tokelau',
    value: 'tk'
  },
  {
    label: 'Tonga',
    value: 'to'
  },
  {
    label: 'Trinidad y Tobago',
    value: 'tt'
  },
  {
    label: 'Túnez',
    value: 'tn'
  },
  {
    label: 'Turquía',
    value: 'tr'
  },
  {
    label: 'Turkmenistán',
    value: 'tm'
  },
  {
    label: 'Islas Turks y Caicos',
    value: 'tc'
  },
  {
    label: 'Tuvalu',
    value: 'tv'
  },
  {
    label: 'Uganda',
    value: 'ug'
  },
  {
    label: 'Ucrania',
    value: 'ua'
  },
  {
    label: 'Emiratos Árabes Unidos',
    value: 'ae'
  },
  {
    label: 'Reino Unido',
    value: 'gb'
  },
  {
    label: 'Estados Unidos',
    value: 'us'
  },
  {
    label: 'Uruguay',
    value: 'uy'
  },
  {
    label: 'Uzbekistán',
    value: 'uz'
  },
  {
    label: 'Vanuatu',
    value: 'vu'
  },
  {
    label: 'Venezuela',
    value: 've'
  },
  {
    label: 'Vietnam',
    value: 'vn'
  },
  {
    label: 'Wallis y Futuna',
    value: 'wf'
  },
  {
    label: 'Sahara Occidental',
    value: 'eh'
  },
  {
    label: 'Yemen',
    value: 'ye'
  },
  {
    label: 'Zambia',
    value: 'zm'
  },
  {
    label: 'Zimbabue',
    value: 'zw'
  }
]



// WEBPACK FOOTER //
// ./src/components/Inputs/Country/countryList/es.js